export function generateImageMarkdown(url) {
  return `![image](${url})`;
}
